<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              clearable
              v-model="search.plateNumber"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for>车主姓名:</label>
            <input
              clearable
              v-model="search.moncardsHostman"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <!-- <span class='add_btn'><button @click="addrOrEdit()" type="button" class="btn btn-default" id="addarea">添加</button></span> -->
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          v-loading="loading"
          :data="tableListData.rows"
          border
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column show-overflow-tooltip label="车牌号" prop="plateNumber"></el-table-column>
          <el-table-column show-overflow-tooltip label="用户名" prop="userName"></el-table-column>
          <el-table-column show-overflow-tooltip label="手机号" prop="phone"></el-table-column>
          <el-table-column show-overflow-tooltip label="卡类型" prop="chargeName"></el-table-column>
          <el-table-column show-overflow-tooltip label="支付时间" prop="payTime"></el-table-column>
          <el-table-column show-overflow-tooltip label="开始时间" prop="startTime"></el-table-column>
          <el-table-column show-overflow-tooltip label="结束时间" prop="endTime"></el-table-column>
        </el-table>
        <!-- <table class="table">
					<thead>
						<tr>
							<td>车牌号</td>
							<td>车牌颜色</td>
							<td>状态</td>
							<td>车型</td>
							<td>车类</td>
							<td>车主名称</td>
							<td>车主电话</td>
							<td>余额</td>
							<td>有效期</td>
							<td>操作</td>
						</tr>
					</thead>
					<tbody id="tbody">
						<tr v-for="item in tableListData.rows" :key='item.plaId'>
							<td>{{item.carNumber}}</td>
							<td>{{item.userName}}</td>
							<td>{{item.userPhone}}</td>
							<td>
								<a  class="margin-right" title="修改" href="javascript:;" @click="addrOrEdit(item.plaId)"><span>修改</span></a>
								<a  class="margin-right" title="删除" href="javascript:;" @click="del(item.plaId)"><span>删除</span></a>
							</td>
						</tr>
						<tr v-if="!tableListData.rows.length" class="empty"><td colspan='10'>暂无数据</td></tr>
					</tbody>
        </table>-->
      </div>
    </div>
    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>

    <!-- 添加或编辑
		<el-dialog title="车辆信息" :visible.sync="dialogFormVisible" :lock-scroll=false width="430px" @close="closeDialog">
		 	<el-form ref="form" label-position="right" :model="form" :rules="rules" :label-width="formLabelWidth" id="form">
		 	
				 <el-form-item label="车型" prop='carNumber' >
		    		<el-col :span="18">
		      			<el-input   clearable v-model.trim="form.carNumber" ></el-input>
		      		</el-col>
		    	</el-form-item>
		    	<el-form-item  label="车牌颜色" prop='userName'>
		    		<el-col :span="18">
		      			<el-input  clearable v-model="form.userName" ></el-input>
						
		      		</el-col>
		    	</el-form-item>
				 <el-form-item label="车场区域" prop='userPhone'>
		    		<el-col :span="18">
		      			<el-input clearable v-model.trim="form.userPhone"  onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
		      		</el-col>
		    	</el-form-item>
				 <el-form-item label="车主姓名" prop='userPhone'>
		    		<el-col :span="18">
		      			<el-input clearable v-model.trim="form.userPhone"  onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
		      		</el-col>
		    	</el-form-item>
				 <el-form-item label="车类" prop='carNumber' >
		    		<el-col :span="18">
		      			<el-input   clearable v-model.trim="form.carNumber" ></el-input>
		      		</el-col>
		    	</el-form-item>
		    	<el-form-item  label="车牌号" prop='userName'>
		    		<el-col :span="18">
		      			<el-input  clearable v-model="form.userName" ></el-input>
						
		      		</el-col>
		    	</el-form-item>
				 <el-form-item label="车主电话" prop='userPhone'>
		    		<el-col :span="18">
		      			<el-input clearable v-model.trim="form.userPhone"  onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
		      		</el-col>
		    	</el-form-item>
				
			</el-form>
		  	<div slot="footer" class="dialog-footer">
		    	<el-button @click="dialogFormVisible = false">取 消</el-button>
		    	<el-button type="primary" @click="addrOrEditTrue()">确 定</el-button>
		 	</div>
    </el-dialog>-->
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import { getCarOwnerList } from "@/api/url";

import Page from "../../commons/page.vue";
import AreaTree from "../../commons/parking/commons/areaTree.vue";
import Refresh from "../../commons/parking/commons/refresh.vue";

export default {
  name:'user-list',
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      manager_btn_edit: false,
      manager_btn_delete: false,
      search: {
        pageNumber: 1,
        pageSize: 12,
        moncardsHostman: "",
        plateNumber: "",
        // carNumber:'',
        // userName:'',
        // userPhone:''
      },
      tableListData: {
        rows: [],
      },
      loading: false,
      formLabelWidth: "100px",
      dialogFormVisible: false,
      // form: {
      // 	id:'',
      // 	name:'',
      //     carNumber:'',
      //     userName:'',
      //     userPhone:''
      // },
      rules: {
        // carNumber:[
        //     {
        //     	required: true,
        //     	trigger: 'blur',
        //     	validator:(rule,value,callback)=>{
        //     		// console.log(rule,value);
        //     		if(value!= ""){
        // 	            if(( /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/).test(value) == false){
        // 	                callback(new Error('车牌号输入有误'));
        // 	            }else{
        // 	                callback();
        // 	            }
        // 	        }else{
        // 	            callback(new Error("请填写车牌号"));
        // 	        }
        //     	}
        //     }
        // ],
        // userName:[
        //     {
        //     	required: true,
        // 		trigger: 'blur',
        // 		 message: '请输入车主',
        //     }
        // ],
        // userPhone:[
        //     {
        //     	required: true,
        //     	trigger: 'blur',
        //     	validator:(rule,value,callback)=>{
        //     		// console.log(rule,value);
        //     		if(value != ""){
        // 	            if((/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/).test(value) == false){
        // 	                callback(new Error("请填写正确手机号"));
        // 	            }else{
        // 	                callback();
        // 	            }
        // 	        }else{
        // 	            callback(new Error("请填写手机号"));
        // 	        }
        //     	}
        //     }
        // ],
      },
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    isJsonObj(obj) {
      try {
        if (typeof JSON.parse(obj) === "object") return true;
      } catch (error) {}
      return false;
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.search.plateNumber = "";
      this.search.moncardsHostman = "";
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.tableListData.rows = [];
        this.treeData.parkingId = "";
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择停车场'
        // })
        return;
      }
    },
    tableList: function (curPage) {
      var _this = this;
      this.loading = true;
      this.$get(getCarOwnerList(), {
        parkingId: this.treeData.parkingId,
        plateNumber: this.search.plateNumber,
        moncardsHostman: this.search.moncardsHostman,
        // carNumber:this.search.carNumber,
        // userPhone:this.search.userPhone,
        // userName:this.search.userName,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        this.loading = false;
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.pageObj={...pageObj}
        // this.getPage(pageObj);
        this.tableListData.rows = data.data.rows;
      }).catch(() => {
        this.loading = false;
      });
    },
    searchList: function () {
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.userName = "";
    },

    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    // 	addrOrEdit:function(id){
    // 		var _this=this;
    // 		this.dialogFormVisible=true;
    // 		if(Boolean(id)){
    //             this.form.id=id;
    //             this.$get(oneWhite()+'/'+id).then(data=>{
    //                 if(data.status!=200) return;
    //                 this.form.carNumber=data.data.carNumber;
    //                 this.form.userName=data.data.userName;
    //                 this.form.userPhone=data.data.userPhone;
    //             })
    // 		}else{
    // 			this.form.id='';
    //             this.form.carNumber='';
    //             this.form.userName='';
    //             this.form.userPhone='';
    // 			return;
    // 		}
    // 	},
    // 	addrOrEditTrue:function(){
    // 		var _this=this;
    // 		this.$refs['form'].validate(function(valid,noStri){

    // 			if(valid){
    // 				_this.dialogFormVisible = false;

    //   				if(!Boolean(_this.form.id)){
    // 					_this.$postRequest(oneWhite(),{
    // 						carNumber:_this.form.carNumber,
    // 						userName:_this.form.userName,
    // 						userPhone:_this.form.userPhone,
    // 					}).then((data) => {
    //                         if(data.status!=200) return;
    //                         _this.search.pageNumber=1;
    //                         _this.search.carNumber='';
    //                         _this.search.userPhone='';
    // 			            _this.tableList(_this.search.pageNumber);
    //       				});
    //       			}else{
    //       				_this.$putRequest(updateOneWhite(),{
    //                         plaId:_this.form.id,
    //       					carNumber:_this.form.carNumber,
    // 						userName:_this.form.userName,
    // 						userPhone:_this.form.userPhone,

    // 					}).then((data) => {
    //         				if(data.status!=200) return;
    // 			            _this.tableList(_this.search.pageNumber);
    //       				});
    //       			}
    // 			}
    // 		});
    // 	},
    // 	del:function(id){
    // 		var _this=this;
    // 		var index=_this.$layer.confirm('您确定删除该管理员？',
    // 		{
    // 		  btn: ['确定','取消'],
    // 		  shade: true
    // 		}, function(){
    // 			_this.$layer.close(index);

    // 			_this.$deleteRequest(oneWhite()+'/'+id).then((data) => {
    // 				if(data.status!=200) return _this.$layer.msg('删除失败', { time: 1});
    // 				_this.tableList(_this.search.pageNumber)
    // 			});

    // 		});
    // 	},
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.manager_btn_edit = this.elements["manager:btn_edit"];
      this.manager_btn_delete = this.elements["manager:btn_delete"];
    },
  },
  components: {
    Page,
    Refresh,
    AreaTree,
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    // this.tableList(this.search.pageNumber);
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
</style>